import { manageCookies } from "@/business/shared/session/infrastructure/utils/manageCookies";

export const isSessionActive = {
  async execute(): Promise<boolean> {
    return manageCookies.exists("userAuth");
  },
};
